import { Text, TextProps } from '@chakra-ui/react'
import { ScalarContentNode } from '@helo/cms'

import { HeadingError } from '../../components/Errors/HeadingError'
import { Skeleton } from '../../components/SkeletonLoader'
import { StringRenderer } from '../../datatypes/String/StringRenderer'
import { ServiceProviderHeaderLayout } from '../ServiceProviderLinkWidget/serviceProviderHeaderLayout'
import { createWidget } from '../widget-utils'
import { TextLayout, type TextWidgetVariant } from './textWidgetLayout'

const resolveContentNodeFontSize = (contentNode: ScalarContentNode) => {
  const styles = contentNode.state?.styles
  if (styles && typeof styles === 'object' && 'fontSize' in styles) {
    return String(styles.fontSize)
  }

  return ServiceProviderHeaderLayout.providerName.height
}

export type TextWidgetProps = TextProps & {
  text?: string
  isLoading?: boolean
  contentNode?: ScalarContentNode
  variant?: TextWidgetVariant
}

export const TextWidget = ({
  children,
  text,
  isLoading,
  contentNode,
  variant,
  ...props
}: TextWidgetProps) => {
  if (contentNode) {
    const fontSize = resolveContentNodeFontSize(contentNode)

    return (
      <Skeleton
        isLoading={!!isLoading}
        w={ServiceProviderHeaderLayout.providerName.width}
        h={fontSize}
        flexShrink={0}
      >
        <StringRenderer contentNode={contentNode} isLoading={false} />
      </Skeleton>
    )
  }
  // TODO:Make sure text widget can render.
  return (
    <Skeleton isLoading={isLoading} w="100px" h={props.fontSize || '18px'}>
      <Text
        lineHeight="1"
        zIndex={1}
        {...props}
        {...TextLayout.variant(variant)}
      >
        {text}
        {children}
      </Text>
    </Skeleton>
  )
}

export const TextWidgetDefinition = createWidget(TextWidget, {
  type: 'Text',
  errorRenderer: HeadingError,
})
